export default basicChapter = `
import App from "@frog/source/models/App.js"
import * as PlotSteps from "@frog/source/data/plot/steps.js"
import * as PlotConditions from "@frog/source/data/plot/conditions.js"
import * as PlotScripts from "@frog/source/data/plot/scripts.js"
import Navigation from "@frog/source/engine/navigating/Navigation.js"
import World from "@frog/source/models/World.js"

export default {
    "slug": chapterNameSlug,
    "stage": {
        "image": require("./tiles.png"),
        "units": require("./units.json"),
        "world": World.parse({
            "blocks": require("./blocks.json"),
            "spots": require("./spots.json"),
            "encounters": require("./encounters.json"),
        }),
        "scripts": [
            scriptedConditions
            {
                // Winning the Level
                "type": "condition",
                "isWinCondition": true,
                "condition": (stage) => {
                    return stage.currentEncounterKey == "lastEncounterKey"
                        && PlotConditions.areAllUnaffiliatedUnitsDefeated(stage, {"affiliation": stage.player.affiliation, "encounterKey": "lastEncounterKey"})
                },
                "events": [
                    PlotSteps.ChapterSuccessClassic(),
                    PlotSteps.SaveGame({"nextChapterSlug": chapterNameSlug}),
                    {"func": () => Navigation.go(linkToNextChapterURLString)},
                ]
            },
            {
                // Losing the Level
                "type": "condition",
                "condition": function(stage) {
                    return PlotConditions.areAllAffiliatedUnitsDefeated(stage, {"affiliation": "good"})
                },
                "events": [
                    PlotSteps.ChapterFailure(),
                    {"func": () => App.game.chapter.restart()},
                ]
            },
        ]
    },
}
`
